export const Colors = {
  MainUSTColor: "#003366",
  SecondaryUSTColor: "#004C98",
  White: "#FFFFFF",
};
